
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { translationDict } from '@/helpers/disneyPlusPromo';
import { TitleDetailsNode } from '@/interfaces/title-details-graphql';

const Language = namespace('language');

@Component({ name: 'DisneyPlusPromo' })
export default class DisneyPlusPromo extends Vue {
	@Prop({ required: true }) title: TitleDetailsNode;

	@Language.Getter country: string;

	get imgUrl(): string {
		return `${JW_CONFIG.IMAGESCALER_URL}/icon/147638351/s100/disneyplus.webp`;
	}

	get offerText(): string {
		return translationDict[this.country].longText;
	}

	get clickOutUrl() {
		return new ClickoutUrl(this.title.watchNowOffer)
			.set('uct_country', this.country)
			.set('uct_tryout', 1)
			.toString();
	}
}
